/** @format */

export interface HomrVisualAsset {
  altText: string;
  type: 'imageUpload' | 'mobileImageUpload' | 'animationUpload';
  value: string;
}

export type HomrVisualAssets = [HomrVisualAsset?, HomrVisualAsset?, HomrVisualAsset?];
